<template>
  <div class="ai-post-gen-schema">
    <div class="ai-post-gen-schema__schema-itself">
      <!-- Step snippet -->
      <div
        :class="{
          'step-snippet': true,
          'step-snippet--tiny': props.size === 'tiny',
          'ai-post-gen-schema__step-snippet': true,
        }"
      >
        <img v-if="props.bgColor === 'white'" class="step-snippet__image" src="/images/aiPostGenSchema/step-1-illustration_white-bg.jpg" alt="" />
        <img v-if="props.bgColor === 'pale-blue'" class="step-snippet__image" src="/images/aiPostGenSchema/step-1-illustration_pale-blue-bg.jpg" alt="" />
        <h5
          :class="{
            'global-h5': true,
            'step-snippet__title': true,
            'step-snippet__title--tiny': props.size === 'tiny',
          }"
        >
          Your Photos &amp; Videos
        </h5>
      </div>
      <!-- / Step snippet -->

      <div
        :class="{
          'ai-post-gen-schema__arrow-container': true,
          'ai-post-gen-schema__arrow-container--tiny': props.size === 'tiny',
        }"
      >
        <IconEmbedded class="ai-post-gen-schema__arrow-icon" name="caret-right_4-5" :size="15" color="rgba(5, 133, 135, 0.3)" />
      </div>

      <!-- Step snippet -->
      <div
        :class="{
          'step-snippet': true,
          'step-snippet--tiny': props.size === 'tiny',
          'ai-post-gen-schema__step-snippet': true,
        }"
      >
        <img v-if="props.bgColor === 'white'" class="step-snippet__image" src="/images/aiPostGenSchema/step-2-illustration_white-bg.jpg" alt="" />
        <img v-if="props.bgColor === 'pale-blue'" class="step-snippet__image" src="/images/aiPostGenSchema/step-2-illustration_pale-blue-bg.jpg" alt="" />
        <h5
          :class="{
            'global-h5': true,
            'step-snippet__title': true,
            'step-snippet__title--tiny': props.size === 'tiny',
          }"
        >
          &nbsp;
        </h5>
      </div>
      <!-- / Step snippet -->

      <div
        :class="{
          'ai-post-gen-schema__arrow-container': true,
          'ai-post-gen-schema__arrow-container--tiny': props.size === 'tiny',
        }"
      >
        <IconEmbedded class="ai-post-gen-schema__arrow-icon" name="caret-right_4-5" :size="15" color="rgba(5, 133, 135, 0.3)" />
      </div>

      <!-- Step snippet -->
      <div
        :class="{
          'step-snippet': true,
          'step-snippet--tiny': props.size === 'tiny',
          'ai-post-gen-schema__step-snippet': true,
        }"
      >
        <img v-if="props.bgColor === 'white'" class="step-snippet__image" src="/images/aiPostGenSchema/step-3-illustration_white-bg.jpg" alt="" />
        <img v-if="props.bgColor === 'pale-blue'" class="step-snippet__image" src="/images/aiPostGenSchema/step-3-illustration_pale-blue-bg.jpg" alt="" />
        <h5
          :class="{
            'global-h5': true,
            'step-snippet__title': true,
            'step-snippet__title--tiny': props.size === 'tiny',
          }"
        >
          AI&nbsp;Generated Posts!
        </h5>
      </div>
      <!-- / Step snippet -->
    </div>

    <SrpButton v-if="props.isWithCtaButton" class="ai-post-gen-schema__cta-button" @click="emit('click:generateButton')">
      <template #icon><IconEmbedded name="plus_3-5" :size="20" /></template>
      Generate from Your Photos
    </SrpButton>
  </div>
</template>

<script setup lang="ts">
// Components
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    size?: "medium" | "tiny";
    isWithCtaButton?: boolean;
    bgColor?: "white" | "pale-blue";
  }>(),
  {
    size: "medium",
    isWithCtaButton: true,
    bgColor: "white",
  }
);

const emit = defineEmits<{
  (e: "click:generateButton"): void;
}>();
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Step snippet ===============================================================
.step-snippet {
  width: 153px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &--tiny {
    width: 90px;
  }

  &__image {
    aspect-ratio: 153/166;
    width: 100%;
    margin-bottom: 3px;
  }

  &__title {
    flex-grow: 1;
    max-width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    font-weight: 500;
    text-wrap: balance;

    &--tiny {
      font-size: 15px;
      line-height: 18px;
    }
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .step-snippet {
    width: 90px;

    &__title {
    }
  }
}

// AI post generation schema ==================================================
.ai-post-gen-schema {
  &__schema-itself {
    gap: 7px;
    margin-bottom: 30px;
    display: flex;
    align-items: flex-start;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__step-snippet {
    height: 100%;
  }

  &__arrow-container {
    width: 50px;
    height: 15px;
    margin-top: 75px;
    display: flex;
    align-items: center;

    &::before {
      content: "";
      flex-grow: 1;
      height: 0;
      margin: -1px -4px 0 0;
      border-bottom: 3px rgba(5, 133, 135, 0.3) dotted !important;
    }

    &--tiny {
      width: 25px;
      margin-top: 42px;
    }
  }

  &__arrow-icon {
    margin-right: -4px;
  }

  &__cta-button {
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .ai-post-gen-schema {
    &__arrow-container {
      width: 25px;
      margin-top: 42px;
    }
  }
}
</style>
